import { Component, Inject, OnDestroy } from '@angular/core';
import { BaseComponent } from '@ridango/core';
import { JourneyDirection, OpenTripPlannerFacade, SearchRecentlyJourney } from '@ridango/components';
import { ActivatedRoute, Router } from '@angular/router';
import { LatLng } from 'leaflet';
import Env from '@ridango/core/env';
import { AnalyticsService } from '@ridango/core/lib/services/analytics.service';
import { TrackedEventCategory } from '@ridango/core/lib/enums/analytics/tracked-event-categories.enum';
import { TrackedEventAction } from '@ridango/core/lib/enums/analytics/tracked-event-action.enum';

@Component({
    selector: 'rwidget-search-recently-journeys',
    templateUrl: './search-recently-journeys.component.html',
    styleUrls: ['./search-recently-journeys.component.scss']
})
export class SearchRecentlyJourneysComponent extends BaseComponent implements OnDestroy {
    readonly BUTTON_LABEL_CLEAR = 'Clear';
    readonly BLOCK_NAME = 'Previous Searches';
    searchRecentlyJourneys$ = this.openTripPlannerFacade.searchRecentlyJourneys$;

    constructor(
        @Inject('ENV') public env: Env,
        private openTripPlannerFacade: OpenTripPlannerFacade,
        private router: Router,
        private route: ActivatedRoute,
        private analyticsService: AnalyticsService
    ) {
        super();
    }

    clearRecentSearch() {
        this.analyticsService.eventTrack(TrackedEventAction.CLICKED, {
            category: TrackedEventCategory.JOURNEY_PLANNER,
            name: `${this.BLOCK_NAME} - ${this.BUTTON_LABEL_CLEAR}`
        });
        this.openTripPlannerFacade.clearSearchRecentlyJourneys();
    }

    onJourneyClick(journey: SearchRecentlyJourney) {
        this.openTripPlannerFacade.setSearchAddress(
            JourneyDirection.Origin,
            journey.origin.name,
            new LatLng(journey.origin.coordinates?.lat, journey.origin.coordinates?.lng),
            journey.origin.useCurrentLocation,
            journey.origin?.useLocationFromMap,
            journey.origin?.municipalityName
        );
        this.openTripPlannerFacade.setSearchAddress(
            JourneyDirection.Destination,
            journey.destination.name,
            new LatLng(journey.destination.coordinates?.lat, journey.destination.coordinates?.lng),
            journey.destination?.useCurrentLocation,
            journey.destination.useLocationFromMap,
            journey.destination?.municipalityName
        );

        this.router.navigate(['../result'], { relativeTo: this.route });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
